
import { useState } from "react";
import { Question } from "@/types/test";

export const useTestQuestions = (initialQuestions: Question[] = []) => {
  console.log('🔍 useTestQuestions initialized with:', initialQuestions);

  const [questions, setQuestions] = useState<Question[]>(initialQuestions);

  const addQuestion = () => {
    const newQuestion: Question = {
      id: crypto.randomUUID(),
      question_type: "multiple_choice",
      content: {
        question: "",
        options: [""],
        correctOption: 0,
      },
      time_limit: null,
      order: questions.length,
      marks: 1,
      skill: null,
      difficulty: null,
      markscheme: null
    };
    console.log('➕ Adding new question:', newQuestion);
    setQuestions([...questions, newQuestion]);
    return newQuestion.id; // Return the ID so the calling component can set it as editing
  };

  const updateQuestion = (questionId: string, updates: Partial<Question>) => {
    console.log(`🔄 Updating question ${questionId} with:`, updates);
    
    // Check if the question exists first
    const questionExists = questions.some(q => q.id === questionId);
    
    if (questionExists) {
      // Update existing question
      setQuestions(questions.map(q => {
        if (q.id === questionId) {
          return { ...q, ...updates };
        }
        return q;
      }));
    } else {
      // Add as a new question if it doesn't exist
      console.log('➕ Adding new question from bank with id:', questionId);
      setQuestions([...questions, { ...updates, id: questionId } as Question]);
    }
  };

  const deleteQuestion = (questionId: string) => {
    console.log(`❌ Deleting question ${questionId}`);
    setQuestions(questions.filter(q => q.id !== questionId));
  };

  const addMultipleQuestions = (newQuestions: Question[]) => {
    console.log(`➕ Adding ${newQuestions.length} questions`);
    
    const currentMaxOrder = questions.length > 0 
      ? Math.max(...questions.map(q => q.order)) 
      : -1;
    
    const questionsWithOrder = newQuestions.map((question, index) => ({
      ...question,
      id: question.id || crypto.randomUUID(),
      order: currentMaxOrder + index + 1,
    }));
    
    setQuestions([...questions, ...questionsWithOrder]);
  };

  return {
    questions,
    setQuestions,
    addQuestion,
    updateQuestion,
    deleteQuestion,
    addMultipleQuestions,
  };
};
